// @flow
export const PRODUCT_PIN_SIZE = 171;
export const PRODUCT_PIN_COMPACT_SIZE = 85;
export const PRODUCT_PIN_CHARACTER_LIMIT = 40;
export const PRODUCT_PIN_CHARACTER_COMPACT_LIMIT = 20;
export const PRODUCT_PIN_COMPACT_SPACING = 8;
export const PRODUCT_PIN_COMPACT_SPACING_LEGO = 4;
export const PRODUCT_PIN_SIZE_LEGO = 106;
export const PRODUCT_PIN_SIZE_HEIGHT_LEGO = 133;
export const PRODUCT_PIN_PADDING = 16;
export const PRODUCT_PIN_NARROW_NUM = 3;
export const PRODUCT_PIN_WIDE_NUM = 5;
export const PRODUCT_PIN_HEIGHT_WIDTH_RATIO = 1.25;
export const PRODUCT_PIN_OVERLAY_OPACITY = 0.2;
export const PRODUCT_PIN_OVERLAY_OPACITY_LEGO = 0.1;
export const PRODUCT_PIN_LETTER_WIDTH = 10;

export const PRODUCT_PINREP_HEIGHT = 246;
export const PRODUCT_PINREP_WIDTH = 197;
export const DEPRECATED_PRODUCT_PINREP_HEIGHT = 206;
export const DEPRECATED_PRODUCT_PINREP_WIDTH = 165;
export const UPDATED_PRODUCT_PINREP_HEIGHT = 295;
export const UPDATED_PRODUCT_PINREP_WIDTH = 236;
